import { z } from 'zod';
import { baseTaskSchema } from '../schema.base.js';
import { checkboxMediaInput } from './input.media.js';

const selectAnswersCheckboxTaskSchema = baseTaskSchema.extend({
  taskType: z.literal("SelectAnswers"),
  answerType: z.literal("Checkbox"),
  answerOptions: z.array(checkboxMediaInput.schema),
  settings: z.object({
    orientation: z.enum(["Vertical", "Horizontal"]).catch("Vertical").default("Vertical")
  }).default({
    orientation: "Vertical"
  })
}).transform(({
  answerOptions,
  ...rest
}) => ({
  ...rest,
  content: answerOptions.map((it, index) => checkboxMediaInput.postprocessSchemaInput(it, {
    taskId: rest.id,
    index
  }))
}));

export { selectAnswersCheckboxTaskSchema };
//# sourceMappingURL=_schema.js.map
